import { Injectable, Injector } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpSentEvent, HttpHeaderResponse, HttpProgressEvent, HttpResponse, HttpUserEvent, HttpErrorResponse } from "@angular/common/http";
// import { Observable } from "rxjs/Observable";
import { Observable } from "rxjs/Rx";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { tap, map } from 'rxjs/operators';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/Observable';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/finally';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/take';

import { AuthenticationService } from "../_services";


@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  isRefreshingToken: boolean = false;
  tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  private authService: AuthenticationService;

  constructor(private injector: Injector) {
  }

  addToken(req: HttpRequest<any>, token: string): HttpRequest<any> {
    return req.clone({setHeaders: {Authorization: 'Bearer ' + token}})
    // return req.clone({setHeaders: {'Access-Control-Allow-Origin': '*'}})
  }

  /*intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>> {
      this.authService = this.injector.get(AuthenticationService);

      return next.handle(this.addToken(req, this.authService.getAuthToken()))
          .catch(error => {
              if (error instanceof HttpErrorResponse) {
                  switch ((<HttpErrorResponse>error).status) {
                      case 400:
                          return this.handle400Error(error);
                      case 401:
                          return this.handle401Error(req, next);
                  }
              } else {
                  return Observable.throw(error);
              }
          });
  }*/


  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>> {
    this.authService = this.injector.get(AuthenticationService);

    return next.handle(this.addToken(req, this.authService.getAuthToken()))
      .pipe(
        tap(event => {
          if (event instanceof HttpErrorResponse) {
            switch ((<HttpErrorResponse>event).status) {
              case 400:
                return this.handle400Error(event);
              case 401:
                return this.handle401Error(req, next);
            }
          } else {
            return Observable.throw(event);
          }
        })
      );
  }

    handle400Error(error) {
        if (error && error.status === 400 && error.error && error.error.error === 'invalid_grant') {
            // If we get a 400 and the error message is 'invalid_grant', the token is no longer valid so logout.
            return this.logoutUser();
        }

        return Observable.throw(error);
    }

    handle401Error(req: HttpRequest<any>, next: HttpHandler) {
        if (!this.isRefreshingToken) {
            this.isRefreshingToken = true;

            // Reset here so that the following requests wait until the token
            // comes back from the refreshToken call.
            this.tokenSubject.next(null);

            return this.authService.refreshToken()
                .switchMap((newToken) => {
                    if (newToken) {
                        var userInfo = JSON.parse(localStorage.getItem('currentUser'));

                        userInfo['access_token'] = newToken.access_token;
                        userInfo['refresh_token'] = newToken.refresh_token;

                        localStorage.setItem("currentUser", JSON.stringify(userInfo));

                        this.tokenSubject.next(newToken.access_token);
                        return next.handle(this.addToken(req, newToken.access_token));
                    }

                    // If we don't get a new token, we are in trouble so logout.
                    return this.logoutUser();
                })
                .catch(error => {
                    // If there is an exception calling 'refreshToken', bad news so logout.
                    return this.logoutUser();
                })
                .finally(() => {
                    this.isRefreshingToken = false;
                });
        } else {
            return this.tokenSubject
                .filter(token => token != null)
                .take(1)
                .switchMap(token => {
                    return next.handle(this.addToken(req, token));
                });
        }
    }



    logoutUser() {
        // Route to the login page (implementation up to you)
        localStorage.removeItem('currentUser');

        return Observable.throw("");
    }
}



// WEBPACK FOOTER //
// ./src/app/_helpers/token.interceptor.ts